import { Component } from '@angular/core';
import { PermissionTypeEnum } from 'src/app/common/permission-enum';

@Component({
  selector: 'app-associations-exit-note',
  templateUrl: './associations-exit-note.component.html',
  styleUrls: ['./associations-exit-note.component.scss']
})
export class AssociationsExitNoteComponent {
  permissionType = PermissionTypeEnum;
  tab = 0;

  

}
